import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

savedOrderListTableStyles.orderDateHeader = {
    css: css`
        > button {
            justify-content: flex-start;
        }
    `,
};

savedOrderListTableStyles.shipToLabelHeader = {
    css: css`
        > button {
            justify-content: flex-start;
        }
    `,
};

savedOrderListTableStyles.subtotalCell = {
    alignX: "right",
    css: css`
        span{
            display: inline-block;
            width: 100%;
            text-align: left;
            max-width: 34%;
           }

        @media (min-width: 992px) and (max-width: 1200px) {
            span{
                max-width: 44%;
               }
        }
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
            text-align: left;
            `,
            css`
            text-align: left;
            `,
            css`
            text-align: center;
            span{
                 max-width: 14%;
                }
            `,
            null,
            null,
        ])}
    `,
}

